import { render, staticRenderFns } from "./editPartners.vue?vue&type=template&id=5dea4e11"
import script from "./editPartners.vue?vue&type=script&lang=js"
export * from "./editPartners.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports